module.exports = __webpack_public_path__ + "static/facebook-0061eac2e9e4a64153c3b36f4f6d903d.png";